<template>
  <v-dialog v-model="dialog" max-width="650" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-on="on" v-bind="attrs"
        ><v-icon>mdi-help-circle-outline</v-icon></v-btn
      >
    </template>
    <v-card :loading="loading">
      <v-card-title class="green lighten-4 primary--text font-weight-bold">{{
        ajuda.descricao
      }}</v-card-title>      
      <v-card-text v-if="conteudoAjuda == ''" class="pt-5">
        <v-alert type="info" text>Ajuda não localizada</v-alert>
      </v-card-text>
      <v-card-text class="pt-5" v-else v-html="conteudoAjuda"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded text @click="dialog = false">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  props: {
    ajuda: Object,
  },
  watch: {
    dialog: async function (open) {
      if (open) {
        this.conteudoAjuda = "";
        this.loading = true;
        var res = await axios.get("/colaborador/atest-config", {
          params: {
            funcao: "exibir-ajuda",
            id: this.ajuda.codigo,
          },
        });
        this.loading = false;
        if (res.status == 200) {
          this.conteudoAjuda = res.data;
        }
      }
    },
  },
  data: () => ({
    dialog: false,
    loading: true,
    conteudoAjuda: "",
  }),
  methods: {},
};
</script>

<style>
</style>